import ajax from '@/plugins/ajax/request'
import { useGlobalStore } from './store'

import URLS from '@Constant/urls'
import { fromOtherSys, loginOption } from '@Utils/system'

/**
 * 设置store的数据
 * @param key
 * @param value
 */
export function setStore(key, value) {
  const globalStore = useGlobalStore()
  globalStore[key](value)
}
const getRouterParams = function (name) {
  let href = location.href
  let query = href.substring(href.indexOf('?') + 1)
  let vars = query.split('&')
  let obj = {}
  for (var i = 0; i < vars.length; i++) {
    let pair = vars[i].split('=')
    obj[pair[0]] = pair[1]
  }
  return obj
}
// 抓取函数参数存在本地, customer 未解析
const saveParams = function (key) {
  try {
    const params = getRouterParams()
    const content = params[key]
    window.sessionStorage.setItem(key, content)
  } catch (e) {
    console.log(e)
  }
}
/**
 * @description 校验用户登陆页面
 * @param init
 */
export const checkIsLogin = function (init) {
  // 针对没有登陆的情况，重定向加参数给品牌银行
  // 并且存在本地, 以便后续使用
  saveParams('customer')

  if (fromOtherSys()) {
    init && init()
  } else {
    let isLogin = location.href === loginOption.WHOLE_URL || location.hash === '#/login' || location.hash === '#/login?bid_grey=1'
    const isHelpCenter = location.hash.indexOf('#/help/') >= 0
    if (isLogin || isHelpCenter) {
      Promise.resolve(init && init())
    } else {
      ajax
        .get(URLS.GET_NEW_USER_INFO, { slient: true })
        .then(
          res => {
            setStore('setAccountInfo', res)
          },
          () => {}
        )
        .finally(function () {
          init && init()
        })
    }
  }
}
